import styled from "styled-components";
import IconButton from "@material-ui/core/IconButton";

export const StyledPageNum = styled(IconButton)`
  && {
    font-size: 18px;

    &:hover {
      background-color: transparent;
    }
  }
`;
